import { insertIntoSupabase, selectFromSupabase, updateInSupabase } from "../helpers/supabase-api";

function toUiStatusPage(dbRow) {
  return {
    id: dbRow.id,
    title: dbRow.title,
    active: Boolean(dbRow.active),
    image: dbRow.image ?? '',
    color: dbRow.color ?? '',
    emergencyMessage: dbRow.emergency_message ?? '',
  };
}

function toDbStatusPage(uiRow) {
  return {
    // Allow caller to provide id (UUID) for stable public URL
    ...(uiRow.id ? { id: uiRow.id } : {}),
    title: uiRow.title,
    active: Boolean(uiRow.active),
    image: uiRow.image ?? '',
    color: uiRow.color ?? '',
    emergency_message: uiRow.emergencyMessage ?? '',
  };
}

export function getStatusPage() {
  return selectFromSupabase("status_pages", "*")
    .then((rows) => ({ data: (rows || []).map(toUiStatusPage) }));
}

/**
 * Create a new status page
 * @param {object} statusPageData - object containing the status page data
 */
export function createStatusPage(statusPageData) {
  return insertIntoSupabase("status_pages", toDbStatusPage(statusPageData))
    .then(toUiStatusPage);
}

/**
 * Update a status page
 * @param {string} id - status page ID to update
 * @param {object} statusPageData - object of data to update
 */
export function updateStatusPage(id, statusPageData) {
  return updateInSupabase("status_pages", toDbStatusPage(statusPageData), { id })
    .then((rows) => (rows && rows[0] ? toUiStatusPage(rows[0]) : null));
}
